import {
  OBTER_CONTRATOS_SUCCESS,
  OBTER_DADOS_SOLICITACAO_REQUEST,
  OBTER_DADOS_SOLICITACAO_SUCCESS,
  OBTER_LIMITE_EMPRESTIMO_REQUEST,
  OBTER_LIMITE_EMPRESTIMO_SUCCESS,
  RESET_EMPRESTIMO,
  SET_SIMULATION,
} from './constants';

const defaultState = {
  limite: {
    requestDone: false,

    parcela: 0,
    total: 0,
    limiteMinimo: 0,
    previstoLiberacao: 0,
    novoContratoBloqueado: false,
    saldoDevedor: 0,
    quantidadeMaximaParcelas: 0,
    taxaFundo: 0,
    taxa: 0,
    taxaMes: 0,
    msgErro: '',
    msgBloqueio: '',
  },
  // aba contratos em aberto
  contratos: [],
  obterContratosDone: false,
  totalParcelasEmAtraso: 0,
  valorTotalEmAtraso: 0,
  valorTotalSaldoDevedor: 0,
  // aba simular e contratar
  simulacao: {
    valor: 0,
    parcelas: 0,
  },
  solicitacao: {
    requestDone: false,
    matrizOpcoesParcelas: [],
    dataPrimeiraParcela: '',
    valorLiberado: 0,
    valorParcelas: 0,
    parcelaMinCalculada: 0,
    dataPrevistaCredito: '',
  },
};

// eslint-disable-next-line default-param-last
export default function emprestimo(state = defaultState, action) {
  switch (action.type) {
    case OBTER_CONTRATOS_SUCCESS:
      return {
        ...state,
        obterContratosDone: true,
        contratos: action.payload.contratos,
        totalParcelasEmAtraso: action.payload.totalParcelasEmAtraso,
        valorTotalEmAtraso: action.payload.valorTotalEmAtraso,
        valorTotalSaldoDevedor: action.payload.valorTotalSaldoDevedor,
      };

    case SET_SIMULATION:
      return {
        ...state,
        simulacao: {
          valor: action.payload.valor,
          parcelas: action.payload.parcelas,
        },
      };

    case OBTER_DADOS_SOLICITACAO_SUCCESS:
      return {
        ...state,
        solicitacao: {
          ...state.solicitacao,
          ...action.payload,
          requestDone: true,
        },
      };

    case OBTER_DADOS_SOLICITACAO_REQUEST:
      return {
        ...state,
        solicitacao: {
          ...state.solicitacao,
          requestDone: false,
        },
      };

    case OBTER_LIMITE_EMPRESTIMO_SUCCESS:
      return {
        ...state,
        limite: {
          ...action.payload,
          requestDone: true,
        },
      };

    case OBTER_LIMITE_EMPRESTIMO_REQUEST:
      return {
        ...state,
        limite: {
          ...state.limite,
          requestDone: false,
        },
      };

    case RESET_EMPRESTIMO:
      return defaultState;

    default:
      return {
        ...state,
      };
  }
}
